import React from "react";
import styled, { css } from "styled-components/macro";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: wrap row;
  justify-content: flex-start;
  overflow-x: hidden;
  overflow-y: hidden;
  padding: 0 20px;
`;
export const MainInputUi = styled.div`
  height: 80px;
  padding: 15px 10px;
  display: flex;
  & input {
    flex-grow: 1;
    border: 2px solid var(--color1);
    border-radius: 0 6px 6px 0px;
    border-left: unset;
    letter-spacing: 4px;
    font-size: 22px;
    text-align: center;
    font-weight: 600;
    color: #666666;
    direction: ltr;
  }
  & button {
    flex-basis: 70px;
    background: var(--color1);
    border: unset;
    border-radius: 5px 0px 0 5px;
  }
  & button:disabled {
    opacity: 0.7;
  }
  & button i {
    color: #fff;
    display: block;
    line-height: inherit;
    font-size: 25px;
  }
`;
const GetCityStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
